import React from "react";
import { euro } from "@/lib/api";

const Row = ({ label, value, testId, strong }) => (
  <span className="flex justify-between gap-4 py-1"><span>{label}</span><span className={strong ? "font-semibold text-foreground" : "text-foreground"} data-testid={testId}>{value}</span></span>
);

export const PecChargeSummary = ({ address, fee, balance }) => {
  const known = fee != null && balance != null;
  const after = known ? Math.round((balance - fee) * 100) / 100 : null;
  return (
    <span className="block space-y-2" data-testid="pec-charge-summary">
      <span className="block">Verrà inviata al fornitore la richiesta per <span className="font-mono text-foreground" data-testid="pec-summary-address">{address}</span>. L'addebito avviene solo se il fornitore registra la richiesta.</span>
      <span className="block rounded-lg border border-border px-3 py-2 text-sm">
        <Row label="Commissione" value={fee != null ? euro(fee) : "—"} testId="pec-summary-fee" />
        <Row label="Saldo attuale" value={balance != null ? euro(balance) : "—"} testId="pec-summary-balance" />
        <span className="block border-t border-border mt-1" />
        <Row label="Saldo dopo l'addebito" value={after != null ? euro(after) : "—"} testId="pec-summary-after" strong />
      </span>
      {known && after < 0 && <span className="block text-destructive" data-testid="pec-summary-insufficient">Plafond servizi insufficiente: ricaricalo prima di attivare.</span>}
      {!known && <span className="block" data-testid="pec-summary-unknown">Saldo o commissione non disponibili al momento: il controllo del Plafond verrà fatto comunque all'invio.</span>}
    </span>
  );
};
